// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1KJcp","actions":"GroupTable_actions__3Td8K","deleteModalFooter":"GroupTable_deleteModalFooter__8ERnv"};